module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ec.190d4b77.png";